export const clientModel = {
  name: '',
  phone: '',
  email: '',
}
